import { useUnit } from 'effector-react';
import { useGetPreparedChangeEvent } from '@nx-frontend/shared/hooks/useChangeEvents/use-get-prepared-change-event';
import { changeEvent } from '@nx-frontend/shared/store/change-events-store';
import { ChangeEvent, ChangeEventWithPartialMeta } from '@nx-frontend/shared/types';

export const useChanges = (): ((event: ChangeEventWithPartialMeta) => ChangeEvent) => {
  const [setChanges] = useUnit([changeEvent]);
  const getPreparedChangeEvent = useGetPreparedChangeEvent();

  return (event: ChangeEventWithPartialMeta) => {
    const changeEvent = getPreparedChangeEvent(event);
    return setChanges(changeEvent);
  };
};
